/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const DisabledIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <rect x="1.45833333" y="1.45833333" width="21.0833333" height="21.0833333" />
      <rect x="8.5" y="6.5" width="7" height="11" />
      <rect x="8.5" y="13.5" width="7" height="4" />
    </g>
  </svg>
);

export default DisabledIcon;
